import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SiteLayout from "@/components/site/SiteLayout";

import Home from "@/pages/Home";
import FeaturesPage from "@/pages/FeaturesPage";
import ShopRegisterPage from "@/pages/ShopRegisterPage";
import AmbassadorPage from "@/pages/AmbassadorPage";
import AboutTime2Cash from "@/pages/AboutTime2Cash";
import AboutDigiswingPage from "@/pages/AboutDigiswingPage";
import TeamPage from "@/pages/TeamPage";
import ReviewsPage from "@/pages/ReviewsPage";
import GalleryPage from "@/pages/GalleryPage";
import ContactPage from "@/pages/ContactPage";
import FAQPage from "@/pages/FAQPage";
import AccountDeletionPage from "@/pages/AccountDeletionPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import RefundPage from "@/pages/RefundPage";
import CareersPage from "@/pages/CareersPage";
import BlogPage from "@/pages/BlogPage";
import QuickLinksPage from "@/pages/QuickLinksPage";
import PreRegistrationPage from "@/pages/PreRegistrationPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SiteLayout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/features" element={<FeaturesPage />} />
            <Route path="/shops/register" element={<ShopRegisterPage />} />
            <Route path="/ambassador" element={<AmbassadorPage />} />
            <Route path="/about" element={<AboutTime2Cash />} />
            <Route path="/about-digiswing" element={<AboutDigiswingPage />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/reviews" element={<ReviewsPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/account-deletion" element={<AccountDeletionPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/refunds" element={<RefundPage />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/links" element={<QuickLinksPage />} />
            <Route path="/pre-registrations" element={<PreRegistrationPage />} />
          </Routes>
        </SiteLayout>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
